"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLModify = void 0;
const react_1 = require("react");
const OLModifyProvider_1 = require("./OLModifyProvider");
function useOLModify(isEditable, feature) {
    const { modifiableFeatures } = react_1.useContext(OLModifyProvider_1.OLModifyContext);
    react_1.useEffect(() => {
        if (isEditable) {
            modifiableFeatures.push(feature);
            return () => {
                modifiableFeatures.remove(feature);
            };
        }
        else {
            return () => { };
        }
    }, [modifiableFeatures, feature, isEditable]);
}
exports.useOLModify = useOLModify;
//# sourceMappingURL=useOLModify.js.map